<div class="modal fade" id="kt_modal_masho_manager_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Masho' : 'Add Masho' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="mashoForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Stock (Searchable) -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Stock</label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" [(ngModel)]="vehicleSearchTerm"
                  [ngModelOptions]="{standalone: true}" (input)="onVehicleSearchInput($event)"
                  (focus)="onVehicleInputFocus()" (blur)="onVehicleInputBlur()" placeholder="Search vehicles..."
                  autocomplete="off" [class.is-invalid]="vehicle_id?.invalid && vehicle_id?.touched"
                  [disabled]="isVehicleSelectionDisabled" [readonly]="isVehicleSelectionDisabled" />

                <!-- Loading indicator -->
                <div *ngIf="isVehicleSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                  <span class="spinner-border spinner-border-sm text-primary"></span>
                </div>

                <!-- Search dropdown -->
                <div *ngIf="showVehicleDropdown && vehicleSearchResults.length > 0 && !isVehicleSelectionDisabled"
                  class="position-absolute w-100 bg-white border border-gray-300 rounded shadow-sm mt-1 z-index-3"
                  style="max-height: 200px; overflow-y: auto; z-index: 1050;">
                  <div *ngFor="let vehicle of vehicleSearchResults"
                    class="p-3 cursor-pointer hover-bg-light-primary border-bottom" (click)="selectVehicle(vehicle)">
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-40px me-3">
                        <img [src]="getVehicleImageUrl(vehicle)" [alt]="vehicle.name || 'Vehicle'" class="symbol-label"
                          style="object-fit: cover;">
                      </div>
                      <div class="flex-grow-1">
                        <div class="fw-bold text-gray-800 fs-6">
                          {{ vehicle.car_no || 'No Stock ID' }}
                        </div>
                        <div class="text-muted fs-7">
                          {{ vehicle.vin_no || 'No Chassis' }} -
                          {{ vehicle.company_name || 'Unknown Make' }}
                          {{ vehicle.name || 'Unknown Model' }}
                          <span *ngIf="vehicle.year">({{ vehicle.year }})</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- No results message -->
                <div
                  *ngIf="showVehicleDropdown && vehicleSearchResults.length === 0 && !isVehicleSearching && vehicleSearchTerm.length >= 2 && !isVehicleSelectionDisabled"
                  class="position-absolute w-100 bg-white border border-gray-300 rounded shadow-sm mt-1 p-3 text-center text-muted"
                  style="z-index: 1050;">
                  No vehicles found
                </div>
              </div>

              <div *ngIf="vehicle_id?.invalid && vehicle_id?.touched" class="invalid-feedback d-block">
                <div *ngIf="vehicle_id?.errors?.['required']">Stock selection is required</div>
              </div>
            </div>

            <!-- Masho Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Masho Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="masho_date"
                [class.is-invalid]="masho_date?.invalid && masho_date?.touched" />
              <div *ngIf="masho_date?.invalid && masho_date?.touched" class="invalid-feedback">
                <div *ngIf="masho_date?.errors?.['required']">Masho date is required</div>
              </div>
            </div>

            <!-- Valid Until Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Valid Until Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="valid_until_date"
                [class.is-invalid]="valid_until_date?.invalid && valid_until_date?.touched" />
              <div *ngIf="valid_until_date?.invalid && valid_until_date?.touched" class="invalid-feedback">
                <div *ngIf="valid_until_date?.errors?.['required']">Valid until date is required</div>
              </div>
            </div>

            <!-- Admin Comment -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Admin Comment</label>
              <textarea class="form-control form-control-solid" formControlName="admin_comment" rows="3"
                placeholder="Enter admin comment..."></textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light me-3" data-bs-dismiss="modal" [disabled]="isLoading">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update Masho' : 'Add Masho' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>